export type SectionTwoActionKey =
  | "view"
  | "sendToSign"
  | "rejectSign"
  | "rollback"
  | "edit"
  | "versions"
  | "delete";

export const getSectionTwoActions = (
  status?: string,
): SectionTwoActionKey[] => {
  switch (status) {
    case "NEW":
      return ["view", "sendToSign", "delete", "edit"];
    case "AWAITING_SIGNATURE":
      return ["view", "rejectSign"];
    case "REJECTED":
      return ["view", "rollback"];
    case "SIGNED":
      return ["view", "versions", "edit"];
    case "SEND_TO_GSN":
      return ["view", "versions"];
    default:
      return ["view", "versions"];
  }
};


